export default "__VITE_ASSET__BDhWEfQk__"